export const RUN_LINE_LOGIC_KIND = {
  DEFAULT: 'default',
  ADJUST_RUN_ROUTES_IN_OUT_1: 'adjustRunRoutesOnOff1',
} as const;
export const NEXT_LINE_REFERENCE = '(次行参照)';
export const ROAD_NAME_SHORT_FORM: Record<number, Record<string, string>> = {
  1: {
    '高速1号羽田線': '羽田',
    '高速1号上野線': '上野',
    '高速2号目黒線': '目黒',
    '高速3号渋谷線': '渋谷',
    '高速4号新宿線': '新宿',
    '高速5号池袋線': '池袋',
    '高速5号池袋線（東京西地区）': '池袋',
    '高速5号池袋線（東京東地区）': '池袋',
    '高速6号向島線': '向島',
    '高速6号三郷線': '三郷',
    '高速7号小松川線': '小松川',
    '高速9号深川線': '深川',
    '高速10号晴海線': '晴海',
    '高速11号台場線': '台場',
    '高速八重洲線': '八重洲',
    '高速都心環状線': '都環',
    '高速中央環状線（東京西地区）': '中環',
    '高速中央環状線（東京東地区）': '中環',
    '高速川口線': '川口',
    '高速埼玉大宮線': '大宮',
    '高速埼玉新都心線': '新都心',
    '高速神奈川1号横羽線': '横羽',
    '高速神奈川2号三ツ沢線': '三ツ沢',
    '高速神奈川3号狩場線': '狩場',
    '高速神奈川5号大黒線': '大黒',
    '高速神奈川6号川崎線': '川崎',
    '高速神奈川7号横浜北線': '横北',
    '高速神奈川7号横浜北西線': '横北西',
    '高速湾岸線（東京地区）': '湾岸',
    '高速湾岸線（神奈川地区）': '湾岸',
  },
  5: {
    '高速1号羽田線': '羽田',
    '高速1号上野線': '上野',
    '高速2号目黒線': '目黒',
    '高速3号渋谷線': '渋谷',
    '高速4号新宿線': '新宿',
    '高速5号池袋線': '池袋',
    '高速5号池袋線（東京西地区）': '池袋',
    '高速5号池袋線（東京東地区）': '池袋',
    '高速6号向島線': '向島',
    '高速6号三郷線': '三郷',
    '高速7号小松川線': '小松川',
    '高速9号深川線': '深川',
    '高速10号晴海線': '晴海',
    '高速11号台場線': '台場',
    '高速八重洲線': '八重洲',
    '高速都心環状線': '都環',
    '高速中央環状線（東京西地区）': '中環',
    '高速中央環状線（東京東地区）': '中環',
    '高速川口線': '川口',
    '高速埼玉大宮線': '大宮',
    '高速埼玉新都心線': '新都心',
    '高速神奈川1号横羽線': '横羽',
    '高速神奈川2号三ツ沢線': '三ツ沢',
    '高速神奈川3号狩場線': '狩場',
    '高速神奈川5号大黒線': '大黒',
    '高速神奈川6号川崎線': '川崎',
    '高速神奈川7号横浜北線': '横北',
    '高速神奈川7号横浜北西線': '横北西',
    '高速湾岸線（東京地区）': '湾岸',
    '高速湾岸線（神奈川地区）': '湾岸',
  },
  16: {
    '中部横断自動車道': 'E52',
    '国道52号': 'R52',
    '国道20号': 'R20',
    '国道20号バイパス': 'R20BP',
    '国道138号': 'R138',
    '国道139号': 'R139',
    '国道139号バイパス': 'R139BP',
  },
};

export const ROUTE_NAME_SHORT_FORM: Record<string, string> = {
  // 首都高
  '高速都心環状線': '都心環状線',
  '高速1号上野線': '1号上野線',
  '高速1号羽田線': '1号羽田線',
  '高速2号目黒線': '2号目黒線',
  '高速3号渋谷線': '3号渋谷線',
  '高速4号新宿線': '4号新宿線',
  '高速5号池袋線': '5号池袋線',
  '高速5号池袋線（東京西地区）': '5号池袋線(西)',
  '高速5号池袋線（東京東地区）': '5号池袋線(東)',
  '高速6号向島線': '6号向島線',
  '高速6号三郷線': '6号三郷線',
  '高速7号小松川線': '7号小松川線',
  '高速9号深川線': '9号深川線',
  '高速10号晴海線': '10号晴海線',
  '高速11号台場線': '11号台場線',
  '高速八重洲線': '八重洲線',
  '高速中央環状線（東京西地区）': '中央環状線(西)',
  '高速中央環状線（東京東地区）': '中央環状線(東)',
  '高速川口線': '川口線',
  '高速埼玉大宮線': '埼玉大宮線',
  '高速埼玉新都心線': '埼玉新都心線',
  '高速神奈川1号横羽線': '神奈川1号横羽線',
  '高速神奈川2号三ツ沢線': '神奈川2号三ツ沢線',
  '高速神奈川3号狩場線': '神奈川3号狩場線',
  '高速神奈川5号大黒線': '神奈川5号大黒線',
  '高速神奈川6号川崎線': '神奈川6号川崎線',
  '高速神奈川7号横浜北線': '神奈川7号横浜北線',
  '高速神奈川7号横浜北西線': '神奈川7号横浜北西線',
  '高速湾岸線（東京地区）': '湾岸線(東)',
  '高速湾岸線（神奈川地区）': '湾岸線(神)',
  'アクアライン（海ほたる）': 'アクアライン(海ほたる)',
  '横横道（港南台）': '横横道(港南台)',
  '横横道（別所）': '横横道(別所)',
  '外環道（草加）': '外環道(草加)',
  '外環道（川口中央）': '外環道(川口中央)',
  '常磐道（柏）': '常磐道(柏)',
  '中央道（調布）': '中央道(調布)',
  '東関道（谷津船橋）': '東関道(谷津船橋)',
  '東京外環道（川口西）': '東京外環道(川口西)',
  '東京外環道（新倉PA）': '東京外環道(新倉PA)',
  '東北道（浦和）': '東北道(浦和)',
  '東名（横浜町田）': '東名(横浜町田)',
  '東名（東名川崎）': '東名(東名川崎)',
  '東名用賀（管理用通路）': '東名用賀(管理用通路)',
  // 甲府河川
  '中部横断自動車道': 'E52',
  '国道52号': 'R52',
  '国道20号': 'R20',
  '国道20号バイパス': 'R20BP',
  '国道138号': 'R138',
  '国道139号': 'R139',
  '国道139号バイパス': 'R139BP',
};
